module.exports = {"530702001":"西安街道","530702002":"大研街道","530702003":"祥和街道","530702004":"束河街道","530702005":"金山街道","530702006":"开南街道","530702007":"文化街道","530702101":"金安镇","530702102":"七河镇","530702203":"大东乡","530702205":"金江白族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530702.json
// module id = 2591
// module chunks = 0